import * as React from 'react';

function SvgAgentAdmin(props) {
  return (
    <svg
      width={38}
      height={40}
      viewBox="0 0 42 41"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g fillRule="evenodd" clipRule="evenodd" fill="#38B2A6">
        <path d="M18.085 19.7c-5.502 0-9.852-4.348-9.852-9.85 0-5.5 4.35-9.85 9.852-9.85 5.502 0 9.851 4.35 9.851 9.85 0 5.267-4.35 9.85-9.851 9.85zm3.818 21.065v-4.27a1 1 0 011.009-1h.084a.5.5 0 00.505-.5V31.5l-.002-1.491c0-.249-.27-.416-.5-.509-2.5-1-2.179-3.323-.497-4.5a452.59 452.59 0 014.998-3.452v-.014H13.97c-6.63 0-10.534 5.032-10.534 5.032-3.668 4.114-3.433 9.85-3.433 9.85 0 3.879 5.949 4.114 5.949 4.114 2.069.235 7.783.235 10.769.235h5.182z" />
        <path d="M32.496 21.127a1.06 1.06 0 011.008 0l7.998 5.362c.882.48.517 1.742-.504 1.742H25.002c-1.021 0-1.386-1.262-.504-1.742l7.998-5.362zM24 37.731a.5.5 0 01.5-.5h17a.5.5 0 01.5.5v2.462a.5.5 0 01-.5.5h-17a.5.5 0 01-.5-.5V37.73zm2.415-1.539V29.27h2.354v6.923h-2.354zm5.402-6.923v6.923h2.354V29.27h-2.354zm5.406 6.923V29.27h2.354v6.923h-2.354z" />
      </g>
    </svg>
  );
}

export default SvgAgentAdmin;
